import { useMemo } from 'react';

import { getFromLocalStorage } from 'widget/actions';
import { useWidgetContext } from 'widget/widget-context';

const useInitialAccessToken = (): string | undefined => {
  const { widget } = useWidgetContext();

  const initialAccessToken = useMemo(
    () =>
      getFromLocalStorage(
        `whatcrmWidgetAccessToken${widget.instance_chat_key}`,
      ) || undefined,
    [],
  );

  return initialAccessToken;
};

export default useInitialAccessToken;
